import request from '../../../../shared/request'

export function getEmployeesList(filters) {
  // mount query string
  let qs = ''
  // filter by name
  if (filters && filters.name) qs += `?name=${filters.name}`

  return request(`/reports/general/tools-report/employees${qs}`)
}

export function getFullReport(filters) {
  // mount query string
  let qs = ''

  // add employee
  if (filters && filters.employee_id) qs += `?employee_id=${filters.employee_id}`

  return request(`/reports/general/tools-report/full-report${qs}`)
}



// WEBPACK FOOTER //
// ./src/redux/api/reports/general/toolsReport.js